import { configureStore } from "@reduxjs/toolkit";
import notificationsReducer from "./slices/notificationsSlice";
import pendingUsersReducer from "./slices/pendingUsersSlice";
import projectHealthStatusReducer from "./slices/ProjectHealthStatusSlice";

export const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    pendingUsers: pendingUsersReducer,
    projectHealthStatus: projectHealthStatusReducer,
  },
});


